<template>
  <div>
    <div>
      <h6 class="text-base inline-block">Details</h6>
    </div>

    <div class="flex -mx-4 mt-8">
      <div class="px-4">
        <ValidationProvider rules="required" vid="issueDate">
          <template #default>
            <BaseFormGroup class="w-48">
              <BaseFormLabel> Issue Date </BaseFormLabel>
              <BaseFormInput v-model="computedIssueDate" type="date" :disabled="disabled" />
            </BaseFormGroup>
          </template>
        </ValidationProvider>
      </div>
      <div class="px-4">
        <BaseFormGroup class="w-48">
          <BaseFormLabel> Offer Number </BaseFormLabel>
          <BaseFormInput :value="offerNumber" disabled />
        </BaseFormGroup>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  components: {
    ValidationProvider,
  },

  props: {
    offerNumber: {
      type: String,
      default: '',
    },
    offerIssueDate: {
      type: String,
      default: '',
    },
    disabled: Boolean,
    locked: Boolean,
  },

  computed: {
    computedIssueDate: {
      get() {
        return this.offerIssueDate;
      },
      set(value) {
        this.$emit('update:offer-issue-date', value);
      },
    },
  },
};
</script>
